import _ from 'lodash'

import CustomAction from './lib/CustomAction'
import services from './services'
import utilities from './utilities'

const state = {}

services.forEach(service => {
  const stateKey = _.camelCase(service.name)

  state[stateKey] = {
    all: [], // Alias of entities (will be depricated in future)
    entity: null,
    entities: [],
    error: '', // Depricating
    errorOnAll: undefined,
    errorOnCreate: undefined,
    errorOnFind: undefined,
    errorOnGet: undefined,
    errorOnList: undefined,
    errorOnRemove: undefined,
    errorOnSave: undefined,
    errorOnUpdate: undefined,
    errors: [], // Depricating
    isAllPending: false,
    isCreatePending: false,
    isFindPending: false,
    isGetPending: false,
    isListPending: false,
    isRemovePending: false,
    isSavePending: false,
    isUpdatePending: false,
    page: 1,
    pageSize: 20,
    removed: null,
    rows: [],
    total: 0,
    totalPages: 0
  }

  service.customActions.forEach(opts => {
    const CA = new CustomAction(opts)

    state[stateKey][`errorOn${CA.getMutationStatusFormat()}`] = undefined
    state[stateKey][`is${CA.getMutationStatusFormat()}Pending`] = false
    state[stateKey][CA.getMutationFormat()] = null
  })
})

utilities.mergeStateExtensions(state)

export default state
